<sirius-grid>
    <div class="container" id="contact-form">
        <sirius-grid>
            <div class="content">
                <div class="header">
                    <div class="titles-container">
                        <p class="mini-title sir-text-style-paragraph-l-bold">{{ translations()!.previewPage.formMiniTitle }}</p>
                        <h2 class="title sir-text-style-title-l-default">{{ translations()!.previewPage.formTitle }}</h2>
                    </div>
                    <sirius-text-html
                        class="description sir-text-style-paragraph-l-default"
                        textStyleSize="l"
                        [html]="translations()?.previewPage?.formDescription ?? ''">
                    </sirius-text-html>
                </div>

                <sirius-form-feature-embedded [config]="formConfig()" />
            </div>
        </sirius-grid>
    </div>
</sirius-grid>
